import EventEmitter from 'events';
import Hls from 'hls.js';

export class HLSMedia extends EventEmitter {
    static Events = {
        DATA: 'DATA',
        ERROR: 'ERROR',
    } as const;

    private hls: Hls;
    private src: string;

    constructor(options: { src: string }) {
        super();
        this.src = options.src;
    }

    init(videoElement: HTMLVideoElement) {
        if (Hls.isSupported()) {
            if (!this.hls) {
                // const hls = new Hls({
                // maxBufferLength: 10,
                //     maxMaxBufferLength: 20,
                //     backBufferLength: 5,
                //     liveSyncDurationCount: 2,
                //     liveMaxLatencyDurationCount: 4,
                //     ignoreDevicePixelRatio: true,
                //     capLevelOnFPSDrop: true,
                //     capLevelToPlayerSize: true,
                //     startFragPrefetch: true,
                //     enableWorker: true,
                //     lowLatencyMode: true,

                // });

                const hls = new Hls({
                    // maxBufferLength: 10,
                    // maxMaxBufferLength: 20,
                    // backBufferLength: 5,
                    // liveSyncDurationCount: 2,
                    // liveMaxLatencyDurationCount: 4,
                    ignoreDevicePixelRatio: true,
                    capLevelOnFPSDrop: true,
                    capLevelToPlayerSize: true,
                    startFragPrefetch: true,
                    enableWorker: true,
                    // lowLatencyMode: true,

                    // / turn on LL-HLS logic
                    lowLatencyMode: true, // enable LL part loading & edge hugging  :contentReference[oaicite:0]{index=0}

                    // start at the live edge
                    autoStartLoad: true,
                    startPosition: -1, // -1 = live edge (do not “rewind”)

                    // how close to the edge to play
                    liveSyncMode: 'edge', // prefer edge vs buffered window
                    liveSyncDurationCount: 2, // ~2 parts/segments from live edge  :contentReference[oaicite:1]{index=1}
                    liveMaxLatencyDurationCount: 4, // if we drift >4 parts/segments, jump forward  :contentReference[oaicite:2]{index=2}
                    maxLiveSyncPlaybackRate: 1.2, // gently speed up to catch up when behind  :contentReference[oaicite:3]{index=3}

                    // keep buffers small so we don’t trail
                    initialLiveManifestSize: 2, // start with minimal playlist depth  :contentReference[oaicite:4]{index=4}
                    maxBufferLength: 5, // cap total buffer (seconds) for agility  :contentReference[oaicite:5]{index=5}
                    backBufferLength: 10, // don’t keep huge history in RAM
                    liveBackBufferLength: 0, // drop anything behind the playhead for “always live”

                    // stability knobs
                    maxBufferHole: 0.2,
                    maxFragLookUpTolerance: 0.2,
                    startOnSegmentBoundary: true,
                    liveSyncOnStallIncrease: 0.5, // nudge closer when stalls happen

                    // retries (optional)
                    appendErrorMaxRetry: 2,
                    testBandwidth: false,
                });

                hls.attachMedia(videoElement);

                hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                    hls.loadSource(this.src);
                });

                this.hls = hls;
            }

            this.hls.on(Hls.Events.FRAG_LOADED, () => {
                this.emit(HLSMedia.Events.DATA);
            });

            this.hls.on(Hls.Events.ERROR, (_, data) => {
                if (import.meta.env.VITE_APP_ENVIRONMENT === 'staging') {
                    console.log('Error ', _, data);
                }

                if (
                    [
                        'fragLoadError',
                        'fragParsingError',
                        'fragLoadTimeOut',
                        'bufferStalledError',
                        'bufferNudgeOnStall',
                        'levelLoadError',
                        'levelLoadTimeOut',
                    ].includes(data.details)
                ) {
                    if (data.frag) videoElement.currentTime = data.frag.start + data.frag.duration + 1.0;
                }

                if (data.fatal) {
                    if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                        this.hls.recoverMediaError();
                    } else if (data.type === Hls.ErrorTypes.NETWORK_ERROR && data.details === 'manifestLoadError') {
                        this.emit(HLSMedia.Events.ERROR);
                    }
                }
            });

            this.hls.on(Hls.Events.DESTROYING, () => {
                this.hls = null;
            });
        } else if (videoElement.canPlayType('application/vnd.apple.mpegURL')) {
            if (!videoElement.src) {
                videoElement.src = this.src;

                videoElement.addEventListener('loadeddata', () => {
                    this.emit(HLSMedia.Events.DATA);
                });

                videoElement.addEventListener('error', () => {
                    this.emit(HLSMedia.Events.ERROR);
                });
            }
        }
    }

    destroy() {
        this.hls?.stopLoad();
        this.hls?.detachMedia();
        this.hls?.destroy();
        this.removeAllListeners();
    }
}
